<template>
  <div class="referrals-page">

    <!-- ================= PAGE TITLE ================= -->
    <div class="page-title" v-if="camp_dt!=null">
      <h1>{{ camp_dt.ref_camp_name }}</h1>
      <p>{{ camp_dt.ref_camp_desc }}</p>
    </div>

    <!-- ================= TOOLBAR ================= -->
    <div class="toolbar">

      <div class="toolbar-left">

        <!-- SEARCH -->
        <div class="search-box">
          <span class="material-symbols-outlined">search</span>
          <input
            v-model="searchQuery"
            placeholder="Search leads..."
          />
        </div>

      </div>

    </div>

  
    <!-- ================= CAMPAIGN TABLE ================= -->
    <div class="table-card">

      <table>
        <thead>
          <tr>
            <th>Referred By</th>
            <th>Referred To</th>
            <th>Referrer Email</th>
            <th>Referrer Phone</th>
            <th>Note</th>
          </tr>
        </thead>

        <tbody>

          <tr
            v-for="camp in campaigns"
            :key="camp.ref_camp_id"
          >

            <!-- CAMPAIGN INFO -->
            <td>
              <div class="customer-cell">

                <div>
                  <div class="name">{{ user_dt.user_name }}</div>
                </div>

              </div>
            </td>

            <!-- TOTAL INVITES -->
            <td>
              {{ camp.ref_inv_name || "" }}
            </td>

            <!-- TOTAL LEADS -->
              <td>
              {{ camp.ref_inv_email || "" }}
            </td>
            <td>
              {{ camp.ref_inv_mobile || "" }}
            </td>

            <!-- REWARD -->
            <td>
               {{ camp.note }}
            </td>
          </tr>

        </tbody>
      </table>
      <div v-if="totalPages > 1" class="pagination">

  <div>
    Showing Page {{ page }} of {{ totalPages }}
  </div>

  <div class="pages">

    <button
      :disabled="page === 0"
      @click="prevPage"
    >
      ‹
    </button>

    <button
      v-for="p in totalPages"
      :key="p"
      :class="{ active: p === page+1 }"
      @click="page = p-1; loadCampaigns()"
    >
      {{ p }}
    </button>

    <button
      :disabled="page+1 === totalPages"
      @click="nextPage"
    >
      ›
    </button>

  </div>

</div>
      <!-- EMPTY STATE -->
      <div v-if="campaigns.length === 0" class="empty-state">
        <span class="material-symbols-outlined">group</span>
        <h3>No Leads Yet</h3>
        <p>there is no lead.</p>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getReferralLeads
} from "../apis/referralapis";


import { useToast } from "vue-toastification";

export default {

  name: "ReferralCampaignsScreen",

  data() {
    return {
    
      toast: null,
      ldata: null,
      page:0,
      total_camp:0,
      campaigns: [],
      camp_dt: null,
      user_dt: null,
      searchQuery: "",
      loading: false,
      camp_id: ""

    };
  },

  mounted() {

    this.toast = useToast();

    const tmp = sessionStorage.getItem("ldata") || "";
    if (tmp) {
      this.ldata = JSON.parse(tmp);
    }

     const params = new URLSearchParams(window.location.search);
    const camp_id = params.get("id");
    if (camp_id) {
      console.log("Referral By:", camp_id);

      this.camp_id = camp_id;   // store in data if needed
      this.loadCampaigns();
    }

    
  },


  computed: {
    totalPages() {
      return Math.ceil(this.total_camp / 10);
    },

  },
  watch: {
  searchQuery: {
    handler() {
      this.page = 0;
      clearTimeout(this.searchTimer);

      this.searchTimer = setTimeout(() => {
        this.loadCampaigns();
      }, 400);
    }
  }
},
  methods: {
    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
        this.loadCampaigns();
      }
    },

    prevPage() {
      if (this.page > 0) {
        this.page--;
        this.loadCampaigns();
      }
    },
    
    /* ================= LOAD CAMPAIGNS ================= */

    async loadCampaigns() {

      this.loading = true;

      try {

        const res = await getReferralLeads(
          this.camp_id,this.page,this.searchQuery
        );

        if (res.status) {
          this.campaigns = res.records || [];
          this.camp_dt = res.camp_dt || null;
          this.user_dt = res.user_dt || null;
          this.total_camp = res.total || 0;
        }

      } catch (err) {
        console.error(err);
        this.toast.error("Failed to load campaigns");
      }

      this.loading = false;
    },

    /* ================= DATE FORMAT ================= */

    beautifyDate(datetime) {

      if (!datetime) return "";

      const date = new Date(datetime.replace(" ", "T"));

      return date.toLocaleString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric"
      });
    },

 
  }

};
</script>
<style scoped>
  .referrals-page {
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: #f6f7f8;
  }

  /* TITLE */

  .page-title h1 {
    font-size: 28px;
    font-weight: 800;
    color: #0f172a;
  }

  .page-title p {
    font-size: 14px;
    color: #64748b;
  }

  /* TOOLBAR */

  .toolbar {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
  }

  .toolbar-left,
  .toolbar-right {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    align-items: center;
  }

  /* SEARCH */

  .search-box {
    height: 40px;
    background: white;
    border-radius: 12px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    border: 1px solid #e2e8f0;
    min-width: 240px;
  }

  .search-box input {
    border: none;
    outline: none;
    font-size: 13px;
    width: 100%;
  }

  /* BUTTONS */

  .primary-btn {
    height: 40px;
    padding: 0 16px;
    background: #197fe6;
    border-radius: 12px;
    color: white;
    font-size: 13px;
    font-weight: 600;
    border: none;
    cursor: pointer;
  }

  .ghost-btn,
  .filter-btn {
    height: 40px;
    padding: 0 14px;
    background: white;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    font-size: 13px;
    font-weight: 600;
  }

  /* METRICS */

  .metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 14px;
  }

  .metric-card {
    background: white;
    border-radius: 16px;
    padding: 18px;
    border: 1px solid #e2e8f0;
  }

  .metric-card span {
    font-size: 12px;
    color: #64748b;
  }

  .metric-card strong {
    font-size: 22px;
    display: block;
    margin-top: 6px;
  }

  /* CUSTOMER */

  .customer-cell {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .avatar {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    background: #197fe6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
  }

  .muted-avatar {
    background: #e2e8f0;
    color: #475569;
  }

  .name {
    font-weight: 600;
  }

  .meta {
    font-size: 12px;
    color: #94a3b8;
  }

  /* REFERRAL LINK */

  .referrer-info {
    display: flex;
    flex-direction: column;
  }

  .ref-link {
    margin-top: 4px;
    background: #f1f5f9;
    border-radius: 8px;
    padding: 5px 6px;
    font-size: 11.5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .ref-link span {
    color: #197fe6;
  }

  /* ACTION BUTTONS */

  .ref-actions {
    display: flex;
    gap: 4px;
  }

  .icon-btn {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    border: none;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .icon-btn span {
    font-size: 14px;
    color: #64748b;
  }

  .icon-btn:hover span {
    color: #197fe6;
  }

  /* STATUS */

  .status {
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .status.successful {
    background: #dcfce7;
    color: #166534;
  }

  .status.pending {
    background: #fef9c3;
    color: #854d0e;
  }

  .status.rejected {
    background: #fee2e2;
    color: #991b1b;
  }

  /* TABLE */

  .table-card {
    background: white;
    border-radius: 18px;
    border: 1px solid #e2e8f0;
    overflow-x: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    min-width: 1100px;
  }

  thead {
    background: #f8fafc;
  }

  th {
    font-size: 11px;
    text-transform: uppercase;
    color: #94a3b8;
    padding: 14px 18px;
  }

  td {
    padding: 16px 18px;
    border-top: 1px solid #f1f5f9;
    font-size: 13px;
  }

  tbody tr:hover {
    background: #f8fafc;
  }

  /* ACTIONS */

  .actions-inline {
    display: flex;
    justify-content: flex-end;
    gap: 6px;
  }

  .mini-btn {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: white;
  }

  /* PAGINATION */

  .pagination {
    padding: 16px 18px;
    border-top: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #64748b;
  }

  /* MOBILE */

  @media(max-width:768px) {

    .toolbar {
      flex-direction: column;
    }

    .search-box {
      width: 100%;
    }

    .metrics-grid {
      grid-template-columns: 1fr;
    }
  }

  /* ================= PAGE ================= */

  .referrals-page {
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: #f6f7f8;
  }

  /* ================= TITLE ================= */

  .page-title h1 {
    font-size: 28px;
    font-weight: 800;
    color: #0f172a;
  }

  .page-title p {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
  }

  /* ================= TOOLBAR ================= */

  .toolbar {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
  }

  .toolbar-left,
  .toolbar-right {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
  }

  /* ================= SEARCH ================= */

  .search-box {
    height: 40px;
    background: white;
    border-radius: 12px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    border: 1px solid #e2e8f0;
    min-width: 240px;
  }

  .search-box span {
    font-size: 18px;
    color: #94a3b8;
  }

  .search-box input {
    border: none;
    outline: none;
    font-size: 13px;
    width: 100%;
  }

  /* ================= BUTTONS ================= */

  .primary-btn {
    height: 40px;
    padding: 0 16px;
    background: #197fe6;
    border-radius: 12px;
    color: white;
    font-size: 13px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: 0.15s;
  }

  .primary-btn:hover {
    background: #166fd1;
  }

  .ghost-btn,
  .filter-btn {
    height: 40px;
    padding: 0 14px;
    background: white;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: 0.15s;
  }

  .filter-btn:hover,
  .ghost-btn:hover {
    background: #f8fafc;
  }

  /* ================= METRICS ================= */

  .metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 14px;
  }

  .metric-card {
    background: white;
    border-radius: 16px;
    padding: 18px;
    border: 1px solid #e2e8f0;
  }

  .metric-card span {
    font-size: 12px;
    color: #64748b;
  }

  .metric-card strong {
    font-size: 22px;
    display: block;
    margin-top: 6px;
  }

  .metric-card small {
    font-size: 11px;
  }

  .positive {
    color: #16a34a;
  }

  .warning {
    color: #f59e0b;
  }

  .neutral {
    color: #94a3b8;
  }

  /* ================= TABLE CARD ================= */

  .table-card {
    background: white;
    border-radius: 18px;
    border: 1px solid #e2e8f0;
    overflow-x: auto;
  }

  /* ================= TABLE ================= */

  table {
    width: 100%;
    border-collapse: collapse;
    min-width: 1100px;
  }

  thead {
    background: #f8fafc;
  }

  th {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    font-weight: 700;
    color: #94a3b8;
    padding: 14px 18px;
    text-align: left;
  }

  td {
    padding: 16px 18px;
    border-top: 1px solid #f1f5f9;
    font-size: 13px;
    color: #0f172a;
    vertical-align: middle;
  }

  tbody tr:hover {
    background: #f8fafc;
  }

  /* ================= CUSTOMER CELLS ================= */

  .customer-cell {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .avatar {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    background: #197fe6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .muted-avatar {
    background: #e2e8f0;
    color: #475569;
  }

  .name {
    font-weight: 600;
    font-size: 13px;
  }

  .meta {
    font-size: 12px;
    color: #94a3b8;
  }

  /* ================= REFERRAL LINK ================= */

  .referrer-info {
    display: flex;
    flex-direction: column;
  }

  .ref-link {
    margin-top: 4px;
    background: #f1f5f9;
    border-radius: 8px;
    padding: 5px 6px;
    font-size: 11.5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    max-width: 260px;
  }

  .ref-link span {
    color: #197fe6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* ================= REFERRAL ACTIONS ================= */

  .ref-actions {
    display: flex;
    gap: 4px;
  }

  /* ================= ICON BUTTONS ================= */

  .icon-btn {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    border: none;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    transition: 0.15s;
  }

  .icon-btn span {
    font-size: 14px;
    color: #64748b;
  }

  .icon-btn:hover span {
    color: #197fe6;
  }

  /* ================= STATUS ================= */

  .status {
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .status.successful {
    background: #dcfce7;
    color: #166534;
  }

  .status.pending {
    background: #fef9c3;
    color: #854d0e;
  }

  .status.rejected {
    background: #fee2e2;
    color: #991b1b;
  }

  /* ================= REWARD ================= */

  .reward {
    font-size: 12px;
    font-weight: 600;
    color: #197fe6;
  }

  /* ================= ACTIONS ================= */

  .actions-inline {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 6px;
  }

  .mini-btn {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.15s;
  }

  .mini-btn span {
    font-size: 18px;
    color: #64748b;
  }

  .mini-btn:hover {
    background: #f1f5f9;
  }

  /* ================= PAGINATION ================= */

  .pagination {
    padding: 16px 18px;
    border-top: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #64748b;
    flex-wrap: wrap;
    gap: 10px;
  }

  .pages {
    display: flex;
    gap: 6px;
  }

  .pages button {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: white;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.15s;
  }

  .pages button:hover:not(:disabled) {
    background: #f8fafc;
  }

  .pages button.active {
    background: #197fe6;
    color: white;
    border-color: #197fe6;
  }

  .pages button:disabled {
    opacity: 0.4;
    cursor: default;
  }

  /* ================= ALIGNMENT ================= */

  .right {
    text-align: right;
  }

  .muted {
    font-size: 12px;
    color: #94a3b8;
  }

  /* ================= MOBILE ================= */

  @media (max-width: 768px) {

    .referrals-page {
      padding: 16px;
    }

    .toolbar {
      flex-direction: column;
    }

    .toolbar-left,
    .toolbar-right {
      width: 100%;
    }

    .search-box {
      width: 100%;
      min-width: unset;
    }

    .filter-btn,
    .ghost-btn,
    .primary-btn {
      flex: 1;
      justify-content: center;
    }

    .metrics-grid {
      grid-template-columns: 1fr;
    }

    .pagination {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  /* ===== MODAL OVERLAY ===== */

  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.45);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }

  /* ===== MODAL CONTAINER ===== */

  .referral-modal {
    width: 440px;
    max-width: 95%;
    background: white;
    border-radius: 18px;
    padding: 22px;
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.18);
    animation: modalEnter 0.18s ease;
  }

  /* ===== HEADER ===== */

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
  }

  .modal-header h3 {
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
  }

  /* ===== CLOSE BUTTON ===== */

  .close-btn {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: none;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.2s;
  }

  .close-btn span {
    font-size: 18px;
    color: #64748b;
  }

  .close-btn:hover {
    background: #e2e8f0;
  }

  .close-btn:hover span {
    color: #0f172a;
  }

  /* ===== BODY ===== */

  .modal-body {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  /* ===== FORM GROUP ===== */

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .form-group label {
    font-size: 12px;
    font-weight: 600;
    color: #475569;
  }

  /* ===== INPUTS ===== */

  .form-group input {
    height: 42px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 0 12px;
    font-size: 13px;
    outline: none;
    transition: 0.2s;
  }

  .form-group input:focus {
    border-color: #197fe6;
    box-shadow: 0 0 0 3px rgba(25, 127, 230, 0.12);
  }

  /* ===== GENERATED LINK BOX ===== */

  .generated-link {
    margin-top: 4px;
    background: #f8fafc;
    border-radius: 12px;
    padding: 10px 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #e2e8f0;
  }

  .generated-link span {
    flex: 1;
    color: #197fe6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* ===== COPY BUTTON ===== */

  .copy-btn {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: none;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.2s;
    flex-shrink: 0;
  }

  .copy-btn span {
    font-size: 18px;
    color: #64748b;
  }

  .copy-btn:hover {
    background: #f1f5f9;
  }

  .copy-btn:hover span {
    color: #197fe6;
  }

  /* ===== ACTIONS ===== */

  .modal-actions {
    margin-top: 10px;
    display: flex;
    gap: 8px;
  }

  .modal-actions button {
    flex: 1;
  }

  /* ===== BUTTON POLISH ===== */

  .modal-actions .ghost-btn,
  .modal-actions .primary-btn {
    height: 40px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
  }

  /* ===== PRIMARY BUTTON ===== */

  .modal-actions .primary-btn {
    background: #197fe6;
    color: white;
    border: none;
    font-weight: 700;
  }

  .modal-actions .primary-btn:hover {
    background: #166fd1;
  }

  /* ===== GHOST BUTTON ===== */

  .modal-actions .ghost-btn:hover {
    background: #f8fafc;
  }

  /* ===== ANIMATION ===== */

  @keyframes modalEnter {
    from {
      transform: translateY(6px) scale(0.98);
      opacity: 0;
    }

    to {
      transform: none;
      opacity: 1;
    }
  }

  /* ===== MOBILE ===== */

  @media (max-width: 640px) {

    .referral-modal {
      width: 100%;
      border-radius: 16px;
      padding: 18px;
    }

    .modal-actions {
      flex-direction: column;
    }

  }

  .dropdown-wrapper {
    position: relative;
  }

  .dropdown-menu {
    position: absolute;
    top: 46px;
    left: 0;
    background: white;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
    width: 180px;
    padding: 6px;
    z-index: 50;
    animation: dropdownEnter 0.15s ease;
  }

  .dropdown-menu div {
    padding: 9px 12px;
    font-size: 13px;
    cursor: pointer;
    border-radius: 8px;
    font-weight: 500;
  }

  .dropdown-menu div:hover {
    background: #f1f5f9;
  }

  @keyframes dropdownEnter {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }

    to {
      opacity: 1;
      transform: none;
    }
  }

  .actions-wrapper {
    position: relative;
    display: flex;
    justify-content: flex-start;
  }

  .row-menu {
    position: absolute;
    top: 38px;
    right: 0;
    width: 180px;
    background: white;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.12);
    padding: 6px;
    z-index: 60;
    animation: menuEnter 0.12s ease;
  }

  .row-menu div {
    padding: 9px 12px;
    font-size: 13px;
    cursor: pointer;
    border-radius: 8px;
    font-weight: 500;
    color: #0f172a;
  }

  .row-menu div:hover {
    background: #f1f5f9;
  }

  .row-menu .divider {
    height: 1px;
    background: #f1f5f9;
    margin: 6px 4px;
  }

  .row-menu .danger {
    color: #ef4444;
    font-weight: 600;
  }

  .row-menu .danger:hover {
    background: #fef2f2;
  }

  @keyframes menuEnter {
    from {
      opacity: 0;
      transform: translateY(-4px) scale(0.98);
    }

    to {
      opacity: 1;
      transform: none;
    }
  }
  /* CONFIRM MODAL */
.confirm-modal {
  width: 380px;
  background: white;
  border-radius: 18px;
  padding: 22px;
  box-shadow: 0 30px 70px rgba(0,0,0,0.18);
  animation: modalEnter 0.18s ease;
}

.confirm-modal h3 {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.confirm-modal p {
  font-size: 13px;
  color: #64748b;
  margin-top: 8px;
  line-height: 1.5;
}

/* ACTIONS */
.confirm-modal .modal-actions {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* DANGER BUTTON */
.danger-btn {
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  border: none;
  background: #ef4444;
  color: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}

.danger-btn:hover {
  background: #dc2626;
}
/* ================= EMPTY STATE ================= */

.empty-state {
  padding: 60px 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
}

.empty-state span {
  font-size: 56px;
  color: #cbd5e1;
}

.empty-state h3 {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.empty-state p {
  font-size: 14px;
  color: #64748b;
  max-width: 360px;
  line-height: 1.6;
}

.empty-state .primary-btn {
  margin-top: 8px;
  height: 42px;
  padding: 0 20px;
  font-weight: 700;
}
</style>